import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

// `type` is required on every endpoint below — Primary Service, Additional Service and
// Terms & Conditions categories are all served by the same backend routes, distinguished
// only by this param, so it must always be passed through.
export const estimateCategoryApi = createApi({
    reducerPath: "estimateCategoryApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["EstimateCategory"],
    endpoints: (builder) => ({
        getAllEstimateCategories: builder.query({
            query: ({ type, pageno, search, status, sortOrder, sortBy, limit }) => {
                let url = `/admin/estimate-categories?type=${type}&pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (status !== undefined && status !== '') {
                    url += `&status=${status}`;
                }
                if (sortOrder && sortBy) {
                    url += `&sortOrder=${sortOrder}&sortBy=${sortBy}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["EstimateCategory"],
        }),
        getActiveEstimateCategories: builder.query({
            query: (type) => ({
                url: `/admin/estimate-categories/active?type=${type}`,
                method: "GET",
            }),
            providesTags: ["EstimateCategory"],
        }),
        addEstimateCategory: builder.mutation({
            query: (data) => ({
                url: `/admin/estimate-category`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["EstimateCategory"],
        }),
        updateEstimateCategory: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/estimate-category/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["EstimateCategory"],
        }),
        deleteEstimateCategory: builder.mutation({
            query: ({ id, type }) => ({
                url: `/admin/estimate-category/${id}?type=${type}`,
                method: "DELETE",
            }),
            invalidatesTags: ["EstimateCategory"],
        }),
    }),
});

export const {
    useGetAllEstimateCategoriesQuery,
    useGetActiveEstimateCategoriesQuery,
    useAddEstimateCategoryMutation,
    useUpdateEstimateCategoryMutation,
    useDeleteEstimateCategoryMutation,
} = estimateCategoryApi;
